<template>
  <div class="flex flex-col gap-4 rounded-sm bg-white p-4">
    <div class="flex w-full items-center gap-4">
      <div class="flex flex-col justify-center">
        <h1 class="mb-1 text-lg text-gray-700">{{ title }}</h1>
      </div>

      <div class="ml-auto">
        <slot name="right" />
        <slot />
      </div>
    </div>

    <div v-if="steps.length > 0" class="flex w-full flex-1 items-center justify-start">
      <Breadcrumb :steps="steps" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'

export default {
  components: {
    Breadcrumb,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
